import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const RandomPurchasePopup = () => {
    const [show, setShow] = useState(false);
    const [data, setData] = useState(null);
    const [availableProducts, setAvailableProducts] = useState([]);

    const names = ['Ali', 'Ahmed', 'Sara', 'Fatima', 'Bilal', 'Zain', 'Ayesha', 'Omar', 'Hassan', 'Mariam'];
    const cities = ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Peshawar', 'Quetta'];

    useEffect(() => {
        // Fetch real products from API
        const fetchProducts = async () => {
            try {
                // Use a relative URL which will be proxied by Vite
                const res = await axios.get('/api/products?limit=100');
                if (res.data && res.data.products) {
                    setAvailableProducts(res.data.products.map(p => p.name));
                }
            } catch (error) {
                console.error("Failed to fetch products for popup:", error);
                // Fallback to generic names if fetch fails
                setAvailableProducts([
                    'Premium T-Shirt', 'Denim Jeans', 'Summer Dress', 'Leather Jacket', 'Running Shoes'
                ]);
            }
        };

        fetchProducts();

        // Initial random delay between 15 seconds
        const initialTimer = setTimeout(() => {
            triggerPopup();
            // Then show every 5 minutes (300,000 ms) as requested
            const interval = setInterval(triggerPopup, 5 * 60 * 1000);
            return () => clearInterval(interval);
        }, 15000);

        return () => clearTimeout(initialTimer);
    }, [availableProducts.length]); // Re-run if products load late, but triggerPopup handles empty check

    const triggerPopup = () => {
        if (availableProducts.length === 0) return;

        const randomName = names[Math.floor(Math.random() * names.length)];
        const randomCity = cities[Math.floor(Math.random() * cities.length)];
        const randomProduct = availableProducts[Math.floor(Math.random() * availableProducts.length)];

        setData({ name: randomName, city: randomCity, product: randomProduct });
        setShow(true);

        // Hide after 6 seconds
        setTimeout(() => {
            setShow(false);
        }, 6000);
    };

    return (
        <AnimatePresence>
            {show && data && (
                <motion.div
                    initial={{ opacity: 0, x: -50, y: 50 }}
                    animate={{ opacity: 1, x: 0, y: 0 }}
                    exit={{ opacity: 0, x: -50, y: 50 }}
                    className="fixed bottom-6 left-6 z-50 bg-white dark:bg-gray-800 rounded-lg shadow-xl p-4 flex items-center gap-4 border border-primary-light/20 max-w-sm"
                >
                    <div className="bg-green-100 dark:bg-green-900/30 p-2 rounded-full">
                        <span className="text-xl">🛍️</span>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                            <span className="font-bold text-primary-light">{data.name}</span> in {data.city}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                            purchased <span className="font-semibold">{data.product}</span>
                        </p>
                        <p className="text-[10px] text-gray-400 mt-1">Just now</p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default RandomPurchasePopup;
